import { createContext } from "preact"
import { useContext, useEffect, useState } from "preact/hooks"

const gettext = window.gettext

const MenuContext = createContext()

export const useMenuContext = () => {
  return useContext(MenuContext)
}

export const MenuProvider = ({ children, ep, contactEp }) => {
  const loc = window.location.pathname.split("/")
  const languageCode = loc[1]
  const path = loc[2]

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [current, setCurrent] = useState(path)
  const [navShown, setNavShown] = useState(path)
  const [messageData, setMessageData] = useState(undefined)

  const handleCityChange = (e) => {
    ep.getData(`menu&city=${e.detail}`).then((epData) => {
      setData(epData)
    })
  }

  const handleExternalPageChange = (e) => {
    setNavShown(true)
    setCurrent(e.detail)
  }

  useEffect(() => {
    window.addEventListener("meldetool_city-change", handleCityChange)
    window.addEventListener(
      "meldetool_open-menu-page",
      handleExternalPageChange,
    )
    return () => {
      window.removeEventListener("meldetool_city-change", handleCityChange)
      window.addEventListener(
        "meldetool_open-menu-page",
        handleExternalPageChange,
      )
    }
  }, [])

  /**
   * Load endpoint data
   */
  if (!loading && !data.length > 0) {
    setLoading(true)
    ep.getData(`menu&city=${document.body.dataset.city}`).then((epData) => {
      setData(epData)
      setLoading(false)
    })
  }

  useEffect(() => {
    let newPath = current ? `/${languageCode}/${current}/` : `/${languageCode}/`
    const currentPage = data.find((p) => p.slug === current)
    if (currentPage?.city) {
      newPath = `${newPath}?city=${currentPage.city}`
    }
    const newPage = current ? currentPage : document.title
    window.history.pushState(null, newPage, newPath)
  }, [current])

  const toggleNav = () => {
    setNavShown(!navShown)
    setCurrent("")
  }

  const onSubmit = async (valueStore, _contactform, _redirect) => {
    const endpoint = contactEp

    const formData = new FormData()

    valueStore.map((o) => {
      formData.append(o.name, o.value)
    })

    const response = await endpoint.postData(formData)

    if (response.valid) {
      setMessageData({
        message: gettext("Consultation request sent!"),
        severity: "ok",
      })
      setCurrent("")
    } else handleValidationErrors(response)
  }

  const handleValidationErrors = (response) => {
    const message = response.message || gettext("Something went wrong")
    setMessageData({
      message,
      severity: "error",
    })
  }

  const value = {
    data,
    loading,
    current,
    navShown,
    messageData,
    ep,
    contactEp,
    setCurrent,
    toggleNav,
    onSubmit,
    setMessageData,
    languageCode,
  }

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>
}
